module.exports = __webpack_public_path__ + "static/media/fundacion-tiempos-mas-nuevos.cb9f2e26.jpg";